'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dIp$002dPayload from "./presto.types$-Ip-Payload.js";
var $p;
/** @constructor */
function $c_Lpresto_types$IpPayload$() {
}
export { $c_Lpresto_types$IpPayload$ as $c_Lpresto_types$IpPayload$ };
$p = $c_Lpresto_types$IpPayload$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$IpPayload$;
/** @constructor */
function $h_Lpresto_types$IpPayload$() {
}
export { $h_Lpresto_types$IpPayload$ as $h_Lpresto_types$IpPayload$ };
$h_Lpresto_types$IpPayload$.prototype = $p;
$p.l = (function() {
  return "IpPayload";
});
$p.cGC = (function(x$0) {
  return new $j_presto$002etypes$0024$002dIp$002dPayload.$c_Lpresto_types$IpPayload(x$0.j(0), x$0.j(1));
});
var $d_Lpresto_types$IpPayload$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$IpPayload$, "presto.types$IpPayload$", ({
  a0x: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$IpPayload$ as $d_Lpresto_types$IpPayload$ };
var $n_Lpresto_types$IpPayload$;
function $m_Lpresto_types$IpPayload$() {
  if ((!$n_Lpresto_types$IpPayload$)) {
    $n_Lpresto_types$IpPayload$ = new $c_Lpresto_types$IpPayload$();
  }
  return $n_Lpresto_types$IpPayload$;
}
export { $m_Lpresto_types$IpPayload$ as $m_Lpresto_types$IpPayload$ };
//# sourceMappingURL=presto.types$-Ip-Payload$.js.map
